const CryptoJS = require("crypto-js");
const key = process.env.REACT_APP_CRYPTO_JS_KEY;

exports.encrypt = (data) => {
    let encJson = CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
    let encData = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encJson))
    return encData
}

exports.decrypt = (data) => {
    try {
        let decData = CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8) || {}
        let bytes = CryptoJS.AES.decrypt(decData, key).toString(CryptoJS.enc.Utf8) || {}
        return JSON.parse(bytes);
    } catch (error) {
        return { error }
    }
}